<template>
  <div class="about-container">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-background">
        <img :src="Images.about.background" alt="Background" class="hero-bg-image">
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <h1 class="hero-title">关于我们</h1>
        <div class="hero-subtitle">
          <img :src="Images.about.to_left" alt="Left dash" class="subtitle-dash">
          <span>ABOUT US</span>
          <img :src="Images.about.to_right" alt="Right dash" class="subtitle-dash">
        </div>
      </div>
    </section>
    
    <main class="about-content">
      <!-- 面包屑导航 -->
      <section class="breadcrumb-section">
        <div class="container">
          <nav class="breadcrumb">
            <router-link to="/home" class="breadcrumb-item">首页</router-link>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-item active">关于我们</span>
          </nav>
        </div>
      </section>
      
      <!-- 关于竞加技术 -->
      <section class="about-section">
        <div class="container">
          <div class="section-title">
          </div>
          <div class="about-content-wrapper">
            <div class="about-text">
              <div class="company-info">
                <div class="info-title">
                  <h1>关于竟加技术</h1>
                  <div class="advantage-divider"></div>
                </div>
                <p class="info-item">
                  <strong>企业定位：</strong>
                  <span>专注于<strong>AI软硬件一体化</strong>的创新型企业，聚集 AI 大模型与硬件端侧优化的专家融合。</span>
                </p>
                <p class="info-item">
                  <strong>核心使命：</strong>
                  <span>通过前沿技术为消费电子行业赋能，为用户提供更智能、高效的产品体验，推动行业向智能化、个性化方向发展。</span>
                </p>
                <p class="info-item">
                  <strong>业务覆盖：</strong>
                  <span>涵盖<strong>AI 大模型与硬件端侧优化、</strong>多屏 UI 交互、嵌入式 AI 应用三大核心领域，服务于 AI 耳机、眼镜、音响、智能机器人、视觉玩具等多个细分市场。</span>
                </p>
              </div>
            </div>
            <div class="about-image">
              <img :src="Images.home.meeting" alt="公司团队">
            </div>
          </div>
        </div>
      </section>

      <!-- 企业文化 -->
      <section class="corporate-culture">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">企业文化</h3>
            <p class="subtitle">我们的核心价值观和企业文化</p>
          </div>
          <div class="culture-cards">
            <div class="culture-card">
              <div class="culture-image">
                <img :src="Images.about.advertisement_1" alt="持续创新">
              </div>
              <div class="culture-content">
                <h3 class="culture-title">持续创新</h3>
                <p class="culture-description">精进技术实力，共赴行业未来</p>
              </div>
            </div>
            <div class="culture-card">
              <div class="culture-image">
                <img :src="Images.about.advertisement_2" alt="客户至上">
              </div>
              <div class="culture-content">
                <h3 class="culture-title">客户至上</h3>
                <p class="culture-description">聚力同心，共创价值</p>
              </div>
            </div>
            <div class="culture-card">
              <div class="culture-image">
                <img :src="Images.about.advertisement_3" alt="追求卓越">
              </div>
              <div class="culture-content">
                <h3 class="culture-title">追求卓越</h3>
                <p class="culture-description">精进不止，行稳致远</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 发展历程 -->
      <section class="development-history">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">发展历程</h3>
            <p class="subtitle">见证竟加技术的成长与发展</p>
          </div>
          <div class="history-content">
            <div class="history-card">
              <h4 class="history-year">2022年</h4>
              <p class="history-description">公司主要营收来源于杰理701N/695N系列芯片，芯片毛利润应该在20%，公司开始组建研发团队，进行智能手表项目产品软硬件研发。</p>
            </div>
            <div class="timeline">
              <div class="timeline-line"></div>
              <div class="timeline-dots">
                <div class="timeline-dot">
                  <span class="year">2019年</span>
                </div>
                <div class="timeline-dot">
                  <span class="year">2020年</span>
                </div>
                <div class="timeline-dot">
                  <span class="year">2021年</span>
                </div>
                <div class="timeline-dot active">
                  <span class="year">2022年</span>
                </div>
                <div class="timeline-dot">
                  <span class="year">2023年</span>
                </div>
                <div class="timeline-dot">
                  <span class="year">2024年</span>
                </div>
                <div class="timeline-dot">
                  <span class="year">2025年</span>
                </div>
              </div>
              <div class="timeline-navigation">
                <button class="nav-btn prev-btn">
                  <span class="btn-icon">&lt;</span>
                </button>
                <button class="nav-btn next-btn">
                  <span class="btn-icon">&gt;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 合作伙伴 -->
      <section class="partners">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">合作伙伴</h3>
            <p class="subtitle">我们携手同行的部分合作伙伴</p>
          </div>
          <div class="partners-grid">
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_1" alt="Partner 1">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_2" alt="Partner 2">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_3" alt="Partner 3">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_4" alt="Partner 4">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_5" alt="Partner 5">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_6" alt="Partner 6">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_7" alt="Partner 7">
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-logo">
                <img :src="Images.about.partner_8" alt="Partner 8">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 核心团队 -->
      <section class="core-team">
        <div class="container">
          <div class="section-title">
            <h3 class="main-title">核心团队</h3>
            <p class="subtitle">我们拥有一个强大的团队</p>
          </div>
          <div class="team-grid">
            <div class="team-item">
              <div class="team-icon">
                <img :src="Images.about.dept_1" alt="嵌入式研发部">
              </div>
              <div class="team-name">嵌入式研发部</div>
              <div class="team-description">负责嵌入式软件开发、芯片适配及调试，保障产品功能稳定落地。</div>
            </div>
            <div class="team-item">
              <div class="team-icon">
                <img :src="Images.about.dept_2" alt="APP研发部">
              </div>
              <div class="team-name">APP研发部</div>
              <div class="team-description">负责配套 APP 开发、测试与迭代，保障移动端交互及设备联动稳定。</div>
            </div>
            <div class="team-item">
              <div class="team-icon">
                <img :src="Images.about.dept_3" alt="硬件研发部">
              </div>
              <div class="team-name">硬件研发部</div>
              <div class="team-description">负责产品硬件方案设计、打样测试与优化，保障硬件性能稳定可靠。</div>
            </div>
            <div class="team-item">
              <div class="team-icon">
                <img :src="Images.about.dept_4" alt="UI设计部">
              </div>
              <div class="team-name">UI设计部</div>
              <div class="team-description">负责产品界面设计、视觉优化与交互设计，打造优质美观的用户体验。</div>
            </div>
            <div class="team-item">
              <div class="team-icon">
                <img :src="Images.about.dept_5" alt="软硬件测试部门">
              </div>
              <div class="team-name">软硬件测试部门</div>
              <div class="team-description">负责产品软硬件功能、性能测试，排查问题，保障产品质达标。</div>
            </div>
          </div>
        </div>
      </section>

    </main>
  </div>
</template>
<script>
import { Images } from '@/utils/imageLoader';

export default {
  name: 'AboutView',
  data() {
    return {
      Images
    };
  }
}
</script>

<style scoped>
.about-container {
  width: 100%;
  min-height: 100vh;
}

/* Hero Section */
.hero {
  position: relative;
  height: 72.5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 80px;
}
.advantage-divider {
  width: 120px;
  height: 6px;
  background: linear-gradient(90deg, #FF9500, #FF5A00);
  margin-bottom: 32px;
}
.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.hero-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));
}

.hero-content {
  text-align: center;
  color: white;
  z-index: 1;
  max-width: 1000px;
  padding: 0 80px;
  margin: 0 auto;
}

.hero-title {
  font-size: 90px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  line-height: 1.2;
  color: #FFFFFF;
}

.hero-subtitle {
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
  color: #FFFFFF;
}

.subtitle-dash {
  width: 60px;
  height: auto;
  object-fit: contain;
}

.hero-subtitle span {
  color: #FFFFFF;
  text-transform: uppercase;
  font-weight: 500;

  gap: 20px;
  color: #FFFFFF;
  margin: 0 auto;
}

.subtitle-dash {
  width: px;
  height: auto;
  object-fit: contain;
}

/* Breadcrumb Section */
.breadcrumb-section {
  padding: 20px 0;
  background-color: #fff;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.breadcrumb-item {
  color: #666;
  text-decoration: none;
}

.breadcrumb-item:hover {
  color: #ff6b00;
}

.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #999;
}

/* Corporate Culture Section */
.corporate-culture {
  padding: 80px 0;
  background-color: #fff;
}

.culture-cards {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 60px;
}

.culture-card {
  flex: 1;
  max-width: 380px;
  position: relative;
  overflow: visible;
  transition: transform 0.3s ease;
}

.culture-card:nth-child(2) {
  align-self: flex-start;
  margin-bottom: 150px;
}

.culture-card:hover {
  transform: translateY(-10px);
}

.culture-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.culture-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.culture-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 70px;
  text-align: center;
  color: #fff;
}

.culture-title {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 12px;
}

.culture-description {
  font-size: 14px;
  color: #fff;
  line-height: 1.5;
}

/* Partners Section */
.partners {
  padding: 80px 0;
  background-color: #fff;
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 60px;
  margin-top: 60px;
  align-items: center;
  justify-items: center;
}

.partner-item {
  width: 100%;
  max-width: 220px;
  height: 100px;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  transition: all 0.3s ease;
}

.partner-item:hover {
  transform: translateY(-2px);
  box-shadow: none;
}

.partner-logo {
  text-align: center;
  padding: 0;
}

.partner-logo img {
  max-width: 100%;
  max-height: 80px;
  height: auto;
  object-fit: contain;
}

/* Development History Section */
.development-history {
  padding: 80px 0;
  background-color: #fff;
}

.history-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
}

.history-card {
  background-color: #fff;
  padding: 40px 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  max-width: 600px;
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
}

.history-year {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.history-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: center;
}

.timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}

.timeline-line {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  transform: translateY(-50%);
  z-index: 0;
}

.timeline-dots {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 800px;
  position: relative;
  z-index: 1;
}

.timeline-dot {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.timeline-dot::before {
  content: '';
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #e0e0e0;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.timeline-dot.active::before {
  width: 16px;
  height: 16px;
  background-color: #ff6b00;
  box-shadow: 0 0 0 4px rgba(255, 107, 0, 0.2);
}

.timeline-dot .year {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  transition: all 0.3s ease;
}

.timeline-dot.active .year {
  color: #ff6b00;
  font-weight: bold;
}

.timeline-navigation {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
}

.nav-btn {
  width: 40px;
  height: 40px;
  border: 2px solid #e0e0e0;
  border-radius: 50%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 18px;
  color: #666;
}

.nav-btn:hover {
  border-color: #ff6b00;
  color: #ff6b00;
}

.btn-icon {
  font-size: 14px;
  font-weight: bold;
}

/* Core Team Section */
.core-team {
  padding: 80px 0;
  background-color: #f8f8fa;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-top: 60px;
  justify-items: center;
}

.team-item {
  background-color: #fff;
  padding: 30px 20px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  max-width: 100%;
  width: 100%;
}

.team-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.team-icon {
  width: 100px;
  height: 100px;
  background-color: transparent;
  color: #ff6b00;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
  font-size: 24px;
  font-weight: 500;
  overflow: hidden;
  padding: 15px;
  box-sizing: border-box;
}

.team-icon img {
  max-width: 80px;
  max-height: 80px;
  height: auto;
  object-fit: contain;
}

.team-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.team-description {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  text-align: center;
  padding: 0 10px;
}

/* About Section */
.about-section {
  padding: 80px 0;
  background-color: #fff;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title .subtitle {
  font-size: 16px;
  color: #212121;
  line-height: 1.5;
  max-width: 800px;
  margin: 0 auto;
}

.about-content-wrapper {
  display: flex;
  align-items: center;
  gap: 40px;
  justify-content: center;
  padding: 0 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.about-text {
  flex: 1;
  max-width: 620px;
  padding: 0;
}

.company-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  font-size: 16px;
  line-height: 2.2;
  color: #000;
}
.info-title h1 {
  font-size: 28px;
  font-weight: bold;
  color: #000;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.info-title{
  margin-bottom: 20px;
}

.advantage-divider {
  margin-bottom: 32px;
}

.info-item {
  font-size: 16px;
}

.info-item strong {
  /* color: #ff6b00; */
  font-weight: bold;
}

.about-image {
  flex: 0 0 auto;
}

.about-image img {
  width: 540px;
  height: auto;
  object-fit: contain;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero {
    height: 400px;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-subtitle {
    font-size: 16px;
  }
  
  .about-content-wrapper {
    flex-direction: column;
    gap: 40px;
  }
  
  .about-image {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }
  
  .info-item {
    font-size: 16px;
  }
  
  .culture-cards {
    flex-direction: column;
    gap: 20px;
  }
  
  .culture-card {
    max-width: 100%;
    width: 100%;
    align-self: center !important;
    margin-bottom: 0 !important;
  }
  
  .culture-image {
    height: 250px;
  }
  
  .culture-content {
    padding: 20px;
  }
  
  .culture-title {
    font-size: 20px;
  }
  
  /* Partners Section Responsive */
  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  .partner-item {
    max-width: 180px;
    height: 90px;
  }
  
  .partner-logo img {
    max-height: 70px;
  }
  
  /* Core Team Section Responsive */
  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .team-item {
    padding: 25px 15px;
  }
  
  .team-icon {
    width: 80px;
    height: 80px;
    font-size: 20px;
    padding: 10px;
  }
  
  .team-icon img {
    max-width: 60px;
    max-height: 60px;
  }
  
  .team-name {
    font-size: 14px;
  }
  
  .team-description {
    font-size: 11px;
  }
  
  /* Development History Section Responsive */
  .development-history {
    padding: 60px 0;
  }
  
  .history-card {
    padding: 30px 20px;
    margin-bottom: 40px;
    max-width: 100%;
  }
  
  .history-year {
    font-size: 18px;
  }
  
  .history-description {
    font-size: 13px;
  }
  
  .timeline-dots {
    max-width: 100%;
    padding: 0 20px;
  }
  
  .timeline-dot::before {
    width: 10px;
    height: 10px;
    margin-bottom: 8px;
  }
  
  .timeline-dot.active::before {
    width: 14px;
    height: 14px;
  }
  
  .timeline-dot .year {
    font-size: 12px;
  }
  
  /* Additional responsive for smaller screens */
  @media (max-width: 480px) {
    .partners-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    
    .team-grid {
      grid-template-columns: 1fr;
      gap: 15px;
    }
    
    .team-icon {
      width: 70px;
      height: 70px;
      padding: 8px;
    }
    
    .team-icon img {
      max-width: 50px;
      max-height: 50px;
    }
    
    /* Development History Section Responsive - Mobile */
    .history-card {
      padding: 25px 15px;
    }
    
    .history-year {
      font-size: 16px;
    }
    
    .history-description {
      font-size: 12px;
    }
    
    .timeline-dots {
      padding: 0 10px;
    }
    
    .timeline-dot .year {
      font-size: 11px;
    }
    
    .nav-btn {
      width: 35px;
      height: 35px;
      font-size: 16px;
    }
  }
}
</style>